exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".main-nav{transition:left .2s ease;position:fixed;z-index:100;left:-3.5rem;top:0;bottom:0;padding-top:3.5rem;background:#516a7d}.main-nav__close{display:none}.open-menu .main-nav{left:0}.open-menu .main-nav__close{position:fixed;z-index:10;left:3.5rem;right:0;top:0;bottom:0;display:block}@media screen and (min-width:36.5em){.main-nav{padding-top:0;left:0}.main-nav__close{display:none!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/MainNav/MainNav.scss
// module id = 683
// module chunks = 0